import sizeIcon from '../../../assets/sizeIcon.png'

interface MeasurementItem {
    id: number
    value: 'width' | 'height' | 'length'
    operator: '=' | 'between' | '>=' | '<='
    first_value: string | null
    second_value: string | null
}

interface MeasurementCriteriaDetailProps {
    id: number
    name: string
    criteria_list: MeasurementItem[]
}

export const MeasurementCriteriaDetail = ({
    name,
    criteria_list,
}: MeasurementCriteriaDetailProps) => {
    const renderMeasurementValues = (item: MeasurementItem) => {
        const { operator, first_value, second_value } = item

        switch (operator) {
            case '=':
                return (
                    <span className="w-max">
                        = {first_value || second_value || 'N/A'} cm
                    </span>
                )

            case 'between':
                return (
                    <span className="w-max">
                        {first_value || 'N/A'} a {second_value || 'N/A'} cm
                    </span>
                )

            case '>=':
                return (
                    <span className="w-max">≥ {first_value || 'N/A'} cm</span>
                )

            case '<=':
                return (
                    <span className="w-max">≤ {second_value || 'N/A'} cm</span>
                )

            default:
                return (
                    <span>
                        {first_value || ''}{' '}
                        {second_value ? `- ${second_value}` : ''} cm
                    </span>
                )
        }
    }

    const measurementLabels = {
        width: 'w',
        height: 'h',
        length: 'l',
    }

    return (
        <div className="flex items-center mb-2">
            <img src={sizeIcon} alt={`${name} icon`} className="mt-1" />
            <div className="ml-2 flex items-center">
                <h3 className="text-[#141A1F] text-[14px] font-normal">
                    {name}:
                </h3>

                <ul className="ml-2  flex items-center flex-wrap gap-2">
                    {criteria_list.length > 0 ? (
                        criteria_list.map((item) => (
                            <li key={item.id}>
                                <span className="bg-[#F1F5F9] text-[#3E5060] flex items-center rounded px-2 py-1 text-sm">
                                    {renderMeasurementValues(item)}(
                                    {measurementLabels[item.value]})
                                </span>
                            </li>
                        ))
                    ) : (
                        <p className="text-gray-400 text-sm">
                            No hay medidas especificadas
                        </p>
                    )}
                </ul>
            </div>
        </div>
    )
}
